import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import type { ClassificationGuideItemProps, ClassificationGuideModalProps } from '@/features/dashboard/types';
import { DialogType, useModal } from '@/hooks/useModal';
import { t } from '@/lib/utils';

export const ClassificationGuideModal = ({ open, setOpen }: ClassificationGuideModalProps) => {
    const { openDialog } = useModal();

    useEffect(() => {
        if (open) {
            openDialog({
                type: DialogType.SIMPLE,
                show: true,
                onClose: () => setOpen(false),
                title: <FormattedMessage id='classificationGuide.title' />,
                body: <ClassificationGuideBody />,
                bsSize: 'md',
                useOverflow: true,
            });
        }
    }, [open, openDialog, setOpen]);

    return null;
};

const ClassificationGuideBody = () => (
    <>
        <img
            src='/classificationGuide.webp'
            alt={t('classificationGuide.imageAltText')}
            data-testid='classification-guide-image'
            height={410}
            className='width-100pct height-auto'
        />
        <h4 className='margin-top-25'>{t('classificationGuide.title')}</h4>
        <p>{t('classificationGuide.description')}</p>
        <div className='margin-left-10'>
            <ClassificationGuideItem
                label='eTruck ready'
                description={t('classificationGuide.description.eTruckReady')}
                iconClass='icon-ok bg-success text-color-white'
            />
            <ClassificationGuideItem
                label='eTruck limited'
                description={t('classificationGuide.description.eTruckLimited')}
                iconClass='icon-exclamation bg-warning text-color-white'
            />
            <ClassificationGuideItem
                label='unspecified'
                description={t('classificationGuide.description.unspecified')}
                iconClass='icon-question bg-info text-color-white'
            />
        </div>
    </>
);

const ClassificationGuideItem = ({ label, description, iconClass }: ClassificationGuideItemProps) => (
    <div className='margin-top-20'>
        <div className='tag rounded padding-5'>
            <div className='tag-inner'>
                <div className='display-flex gap-10'>
                    <span className='uikit-icon-pair text-size-16'>
                        <span className='uikit-icon icon-truck text-color-black' />
                        <span className={`uikit-icon ${iconClass}`} />
                    </span>
                    <span className='text-size-14'>{label}</span>
                </div>
            </div>
        </div>
        <p className='margin-top-5'>{description}</p>
    </div>
);
